import { useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, CircularProgress } from "@mui/material";
import { deleteCity } from "../../../../../services/Admin/ShippingCategoriesApi";

const DeleteCityDialog = ({ open, onClose, onSuccess, city }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleDelete = async () => {
    if (!city?.id) return;
    setError("");
    setLoading(true);
    try {
      const res = await deleteCity(city.id);
      if (res?.success) {
        onSuccess?.();
        onClose?.();
      } else {
        setError(res?.message || "فشل حذف المدينة");
      }
    } catch (err) {
      setError(err?.message || "حدث خطأ أثناء الحذف");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>تأكيد حذف المدينة</DialogTitle>
      <DialogContent>
        <Typography>
          هل أنت متأكد من حذف المدينة <strong>{city?.name_ar || city?.name_en || ""}</strong>؟
        </Typography>
        {error && <Typography color="error" sx={{ mt: 1 }}>{error}</Typography>}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>إلغاء</Button>
        <Button variant="contained" color="error" onClick={handleDelete} disabled={loading}>
          {loading ? <CircularProgress size={20} /> : "حذف"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteCityDialog;
